<template>
  <div>
    <h1 class="display-1 primary--text">
      {{ $t('message.targets_list_title') }}
    </h1>

    <v-data-table
      v-if="Object.keys(users).length > 0 && targetsList.length > 0"
      :headers="headers"
      :items="targetsList"
      class="elevation-1"
      :pagination.sync="pagination"
      item-key="date"
    >
      <template v-slot:items="row">
        <tr @click="onSelect(row.item)">
          <td>{{ users[row.item.userId] | fullName }}</td>
          <td>
            <v-icon
              v-if="!row.item.isDraft"
              color="success"
            >
              fa-check
            </v-icon>
          </td>
          <td>
            <v-icon
              v-if="row.item.approvedOn"
              color="success"
            >
              fa-check
            </v-icon>
            <v-icon
              v-else-if="!row.item.isDraft"
              color="error"
            >
              fa-eye
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'TargetsList',
  data: (vm) => ({
    headers: [
      { text: vm.$t('message.user'), value: 'userId' },
      { text: vm.$t('message.ready_for_approval'), value: 'isDraft' },
      { text: vm.$t('message.approved'), value: 'approvedOn' },
    ],
    dialog: false,
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: -1, // -1 for All",
      sortBy: 'date',
    },
  }),
  computed: {
    ...mapState({
      targetsList: (state) => state.targetsList,
      users: (state) => {
        let usersMap = {}
        state.users.forEach((u) => {
          usersMap[u._id] = u
        })
        return usersMap
      },
    }),
  },
  created() {
    this.$store.dispatch('getTargetsList')
    this.$store.dispatch('getUsers')
  },
  methods: {
    save: function () {
      this.dialog = false
    },
    onSelect(item) {
      const targetId = item._id
      this.$router.push({ name: 'targets', params: { targetId } })
    },
    draftIcon(value) {
      return value ? 'fa-minus' : 'fa-check'
    },
  },
}
</script>
<style scoped>
tr {
  cursor: pointer;
}
</style>
